import { useState } from "react";
import { FaBed, FaBath, FaRulerCombined, FaMapMarkerAlt } from "react-icons/fa";
import { toDisplayName } from "../../application/normalizeText";

const House = ({ house }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <div className="group relative overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 bg-white w-full flex flex-col justify-center items-center">
      <div className="sm:w-full w-[95vw]">
        {/* Imagen con overlay hover */}
        <div className="relative h-60 w-full overflow-hidden">
          {!isImageLoaded && (
            <div className="absolute inset-0 animate-pulse bg-gray-200" />
          )}
          <img
            src={house.images[0]}
            alt={house.name}
            onLoad={() => setIsImageLoaded(true)}
            className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${
              isImageLoaded ? "opacity-100" : "opacity-0"
            }`}
          />

          {/* Badge de estado */}
          <div className="absolute top-3 left-3 bg-primary text-white text-xs font-bold px-6 py-2 rounded-sm shadow-md">
            {toDisplayName(house.state)}
          </div>

          {/* Overlay hover */}
          <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
            <button className="bg-white text-primary font-semibold px-4 py-2 rounded-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              Ver detalles
            </button>
          </div>
        </div>

        {/* Contenido */}
        <div className="p-4">
          <div className="flex justify-between items-start mb-2">
            <h3 className="text-lg font-bold text-gray-900 truncate">
              {house.name}
            </h3>
            <p className="text-lg font-bold text-primary whitespace-nowrap">
              {house.currency} {house.price || ""}
            </p>
          </div>

          <div className="flex items-center text-gray-600 mb-3">
            <FaMapMarkerAlt className="mr-1 text-sm" />
            <p className="text-sm truncate">{house.address}</p>
          </div>

          {/* Características */}
          <div className="flex justify-between border-t border-gray-100 pt-3">
            <div className="flex items-center text-gray-700">
              <FaBed className="mr-1" />
              <span className="text-sm">
                {house.characteristics?.dormitorios || 0}
              </span>
            </div>
            <div className="flex items-center text-gray-700">
              <FaBath className="mr-1" />
              <span className="text-sm">
                {house.characteristics?.baños || 0}
              </span>
            </div>
            <div className="flex items-center text-gray-700">
              <FaRulerCombined className="mr-1" />
              <span className="text-sm">
                {house.characteristics?.superficie || 0} m²
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default House;
